import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { mixins, media } from "Styles"
import { theme } from "Theme"
import { Link, ActionButton } from "Components"
const { colors } = theme

const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  outline: 0;
  transition: ${theme.transition};
  transform: translateX(${(props) => (props.menuOpen ? 0 : 100)}vw);
  visibility: ${(props) => (props.menuOpen ? "visible" : "hidden")};
  display: none;
  ${media.desktop`display: block;`};
`
const Sidebar = styled.div`
  ${mixins.flexCenter};
  flex-direction: column;
  width: 100vw;
  height: 100%;
  position: relative;
  right: 0;
  margin-left: auto;
  padding:1rem;
  &:before {
    content: '';
    position: absolute;
    top: 80px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.95) 0%,
      rgba(0, 0, 0, 0.95) 100%
    );
  }
`

const Nav = styled.nav`
  padding-top: ${theme.headerScrollHeight}
  height: 100%;
  width: 100%;
  color: ${colors.white.base};
  z-index: 1;
`

const NavLinks = styled(Nav)`
  ${mixins.flexBetween};
  flex-direction: column;
  text-align: left;
  color: black;
  justify-content: space-between;
  height: 90vh;
  padding: ${theme.headerScrollHeight} 0 ${theme.headerScrollHeight};
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    height: auto;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const NavList = styled.ul`
  margin: 0;
  width: 100%;
`
const NavListItem = styled.li`
  margin: 0 auto 20px;
  position: relative;
  color: ${colors.white.base};
`

const NavListItems = styled.li`
  margin: 0 auto 20px;
  position: relative;
  color: ${colors.white.base};
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const MenuHeader = styled.p`
  font-size: 16px;
  margin: 6px 0;
  position: relative;
  color: #aaa;
  hr {
    width: 100%;
    background: ${colors.white.base};
  }
`

const NavLink = styled((props) => <Link {...props} />)`
  ${mixins.link};
  font-size: 1.2rem;
  padding: 6px 10px;
  font-weight: bold;
  border: 1px solid #fff;
  border-radius: ${theme.borderRadius.elements};
  &.activeItem {
    box-shadow: inset 0px -2px ${colors.primary.base};
  }
`

const Menu = ({
  navLinks,

  menuOpen,
  handleMenuClick,
  button_text,
  button_action,

  modalClick,
  path,
}) => {
  const homepage = path === "/" ? true : false
  return (
    <MenuContainer menuOpen={menuOpen} aria-hidden={!menuOpen} tabIndex={menuOpen ? 1 : -1}>
      <Sidebar>
        <NavLinks>
          <NavList>
            {navLinks &&
              navLinks.map(({ url, name, offset,section_ref }, i) => (
                <span key={i}>
                  {url && (
                    <NavListItem key={i}>
                      <NavLink to={url} offset={offset} section_ref={section_ref} track={"Menu"} title={name} onClick={handleMenuClick}>
                        {name}
                      </NavLink>
                    </NavListItem>
                  )}
                </span>
              ))}
            {/* {homepage && (
              <>
                <MenuHeader>Events For:</MenuHeader>
                <span key={"cio"}>
                  <NavListItems>
                    <NavLink to={"#cio"} offset={"120"} track={"Menu"} title={`CIO Events`} onClick={handleMenuClick}>
                      CIOs
                    </NavLink>
                    |
                    <NavLink to={"#ciso"} offset={"120"} track={"Menu"} title={`CISO Events`} onClick={handleMenuClick}>
                      CISOs
                    </NavLink>
                    |
                    <NavLink to={"#cmo"} offset={"120"} track={"Menu"} title={`CMO Events`} onClick={handleMenuClick}>
                      CMOs
                    </NavLink>
                    |
                    <NavLink to={"#cfo"} offset={"120"} track={"Menu"} title={`CFO Events`} onClick={handleMenuClick}>
                      CFOs
                    </NavLink>
                  </NavListItems>
                </span>
              </>
            )} */}
          </NavList>
          {modalClick && (
            <>
              <ActionButton
                className={`action-cta`}
                style={{ fontSize: "1.4rem", marginTop: "3rem" }}
                track={"Menu"}
                onClick={modalClick}
                title={"Agenda"}>
                {"Agenda"}
              </ActionButton>
            </>
          )}
          {button_text && button_action && (
            <>
              <ActionButton
                className={`action-cta`}
                style={{ fontSize: "1.4rem", marginTop: "3rem" }}
                track={"Menu Button"}
                onClick={button_action}
                title={button_text}>
                {button_text}
              </ActionButton>
            </>
          )}
        </NavLinks>
      </Sidebar>
    </MenuContainer>
  )
}

export default Menu

Menu.propTypes = {
  menuOpen: PropTypes.bool.isRequired,
  navLinks: PropTypes.array.isRequired,
}

Menu.defaultProps = {
  menuOpen: false,
  navLinks: false,
}
